module.exports = __webpack_public_path__ + "img/ILOILOCSR.f24a940a.jpg";